import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutErrorsCenterComponent } from './layout-errors-center.component';
@NgModule({
  declarations: [LayoutErrorsCenterComponent],
  imports: [CommonModule],
  exports: [LayoutErrorsCenterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutErrorCenterModule {}
